import { render, staticRenderFns } from "./ProblemSimples.vue?vue&type=template&id=01bff7f8&"
import script from "./ProblemSimples.vue?vue&type=script&lang=js&"
export * from "./ProblemSimples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports